import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  formItem: {
    margin: 0,
    width: '100%',

    '.ant-picker': {
      width: '100%'
    }
  },

  cardActionsInner: {
    cursor: 'default',
    padding: `0 10px`
  },

  tabsCard: {}
}))
